<template>
    <div>
        <v-select
            v-if="autocompleteDisabled"
            ref="option"
            :model-value="value"
            :name="name"
            :items="items"
            :label="$attrs.label"
            :counter="$attrs.counter"
            item-title="name"
            :search="search"
            closable-chips
            item-value="value"
            :single-line="singleLine"
            variant="outlined"
            hide-details
            :multiple="multiple"
            :clearable="clearable"
            :density="dense ? 'compact' : 'comfortable'"
            :disabled="disabled"
            @update:model-value="change"
            @update:search="onSearch"
        />
        <v-autocomplete
            v-else
            ref="option"
            :model-value="value"
            :name="name"
            :items="items"
            :label="$attrs.label"
            :counter="$attrs.counter"
            item-title="name"
            :search="search"
            closable-chips
            item-value="value"
            :single-line="singleLine"
            variant="outlined"
            hide-details
            :multiple="multiple"
            :clearable="clearable"
            :density="dense ? 'compact' : 'comfortable'"
            :disabled="disabled"
            @update:model-value="change"
            @update:search="onSearch"
        />
    </div>
</template>

<script lang="ts">
    import {Component, Emit, Prop, Vue} from 'vue-facing-decorator'
    import {AUTH_EVENT, EventBus} from '@/utils/event-bus'

    @Component({})
    export class SelectOption extends Vue {
        @Prop({default: false, type: Boolean}) autocompleteDisabled
        @Prop({default: false, type: Boolean}) disabled
        @Prop({default: false, type: Boolean}) outlined
        @Prop({default: true}) singleLine
        @Prop({default: true}) clearable
        @Prop({required: true}) name
        @Prop({default: () => []}) items
        @Prop() defaultValue
        @Prop({required: false, type: Boolean}) multiple
        @Prop({required: false, type: Boolean}) dense

        value = null
        search = ''

        @Emit()
        change(value) {
            this.value = value
            this.$refs.option.blur()

            return {value, name: this.name}
        }

        onSearch(val) {
            this.search = val
        }

        mounted() {
            EventBus.$on(AUTH_EVENT, this.setDefaultCitizenship)
            if (
                this.name === 'citizenshipId' ||
                this.name === 'driverCitizenshipId' ||
                this.name === 'applicantCountryId'
            ) {
                this.value = +this.defaultValue
            } else if (
                typeof this.$route.query[this.name] === 'string' &&
                /^\d+$/.test(this.$route.query[this.name] as string)
            ) {
                this.value = +this.$route.query[this.name] || this.defaultValue
            } else {
                this.value = this.$route.query[this.name] || this.defaultValue
            }
        }

        beforeUnmount() {
            EventBus.$off(AUTH_EVENT, this.setDefaultCitizenship)
        }

        setDefaultCitizenship() {
            if (
                (this.name === 'citizenshipId' ||
                    this.name === 'driverCitizenshipId' ||
                    this.name === 'applicantCountryId') &&
                this.$route.name === 'home'
            ) {
                this.$nextTick(() => {
                    this.value = this.defaultValue
                })
            }
        }
    }

    export default SelectOption
</script>
